export const not =
  <T>(func: (value: T) => boolean) =>
  (value: T): boolean =>
    !func(value);
